<template>
    <div class="modal is-active">
        <div class="modal-background" />
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title px-4">
                        {{$t("game_session_configuration")}} 
                        <span class="icon is-pulled-right is-clickable" @click="showInfo=!showInfo">
                            <i class="mdi mdi-24px mdi-help-circle-outline" />
                        </span>
                    </p>
                </header>
                <section class="modal-card-body pt-0">
                    <div class="px-4 pb-4" >
                        
                        <div class="game-creation-info" v-if="showInfo">
                            <p class="pb-4">{{$t("game_session_creation_hint")}}</p>
                        </div>

                        <div v-if="showCreationError" class="notification is-danger">
                            <button class="delete" @click="showCreationError = false"></button>
                            {{ creationError }}
                        </div>

                        <form class="">
                            <div class="columns is-mobile is-vcentered is-multiline">
                                
                                <div class="column is-12 pb-4">
                                    <label
                                        v-t="'game_session_title'"
                                        class="label has-text-black pb-0" 
                                    ></label>
                                    <div class="control">
                                        <input v-model="title" ref="titleSession" class="input secondary-font" type="text" :placeholder="$t('game_session_title_hint')">
                                    </div>
                                </div>
                                
                                

                                <!-- Es pot jugar més d'una vegada? -->
                                <label
                                    v-t="'game_session_user_behaivour'"
                                    class="label has-text-black px-4 column is-12 pb-0" 
                                ></label>
                                
                                <div class="column is-6 pr-0 pl-4 pt-0">
                                    <p
                                        ref="canResetButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        :class="{'is-primary':allowsReset}"
                                        @click.stop="setResetOn"
                                    >
                                        {{$t(`game_session_user_can_reset`)}}
                                    </p>
                                </div>
                                <div class="column is-6 pl-0 pr-4 pt-0">
                                    <p
                                        ref="preventResetButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        :class="{'is-primary':!allowsReset}"
                                        @click.stop="setResetOff"
                                    >
                                        {{$t(`game_session_user_prevent_reset`)}}
                                    </p>
                                </div>
                                <!-- FI -->

                                <!-- Configuracions específiques del memory -->
                                <div v-if="isMemory||isQuizHunt" style="width: 100%;">
                                    <label 
                                        v-t="'game_session_memory_cards_behaivour'"
                                        class="label has-text-black px-4 column is-12 pb-2" 
                                    ></label>
                                    <div class="columns px-2 mb-0">
                                        <div class="column is-6 pr-0 pl-4 pt-0">
                                            <p
                                                ref="mapButton"
                                                class="
                                                    button
                                                    is-light is-multiline is-fullwidth
                                                "
                                                :class="{}"
                                                @click.stop="setMapOn"
                                            >
                                                <span v-if="isQuizHunt">{{$t(`game_session_quizhunt_map`)}}</span><span v-else>{{$t(`game_session_memory_map`)}}</span>
                                            </p>
                                        </div>
                                        <div class="column is-6 pl-0 pr-4 pt-0">
                                            <p
                                                ref="cardButton"
                                                class="
                                                    button
                                                    is-light is-primary is-multiline is-fullwidth
                                                "
                                                @click.stop="setMapOff"
                                            >
                                                <span v-if="isQuizHunt">{{$t(`game_session_quizhunt_choose`)}}</span><span v-else>{{$t(`game_session_memory_choose`)}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <label
                                            v-if="configuration.mode=='MAP' && isQuizHunt"
                                            v-t="'game_session_quizhunt_map_desc'"
                                            class="label is-italic pl-4 desc-label"
                                        ></label>
                                        <label
                                            v-if="configuration.mode!='MAP' && isQuizHunt"
                                            v-t="'game_session_quizhunt_choose_desc'"
                                            class="label is-italic pl-4 desc-label"
                                        ></label>
                                        <label
                                            v-if="configuration.mode=='MAP' && isMemory"
                                            v-t="'game_session_memory_map_desc'"
                                            class="label is-italic pl-4 desc-label"
                                        ></label>
                                        <label
                                            v-if="configuration.mode!='MAP' && isMemory"
                                            v-t="'game_session_memory_choose_desc'"
                                            class="label is-italic pl-4 desc-label"
                                        ></label>
                                    </div>

                                    <!--<label 
                                        v-t="'game_session_memory_draw_shape'"
                                        class="label has-text-black px-4 column is-12 pt-3 mb-0 pb-1" 
                                        v-if="configuration.mode=='MAP'"
                                    ></label>-->

                                    <!--<button
                                        class="button is-eduloc-blue"
                                        @click="addPolygon"
                                        :disabled="shapeAdded"
                                        :title="$t('draw_rectangle')"
                                    >
                                        {{ $t('game_session_memory_draw_shape') }}
                                    </button>-->
                                    <div class="map-controls px-3 pt-2" v-if="configuration.mode=='MAP'">
                                        <ul class="steps has-content-centered">
                                            <li class="steps-segment" :ref="'step1'" :class="{ 'is-active': !shapeAdded }">
                                                <span class="steps-marker"></span>
                                                <div class="steps-content">
                                                    <p class="is-size-5">{{ $t('Import.step1') }}</p>
                                                    <p>{{ $t('game_session_memory_draw_shape') }}</p>
                                                    
                                                </div>
                                            </li>
                                            <li class="steps-segment" :ref="'step2'" :class="{ 'is-active': shapeAdded && !cardsDrawed }">
                                                <span class="steps-marker"></span>
                                                <div class="steps-content">
                                                    <p class="is-size-5">{{ $t('Import.step2') }}</p>
                                                    <p>
                                                        {{ $t('game_session_memory_draw_cards') }}
                                                    </p>
                                                    
                                                </div>
                                            </li>
                                            <li class="steps-segment" :ref="'step3'" :class="{ 'is-active': cardsDrawed }">
                                                <span class="steps-marker"></span>
                                                <div class="steps-content">
                                                    <p class="is-size-5">{{ $t('Import.step3') }}</p>
                                                    <p>
                                                        {{ $t('game_session_memory_move_cards') }}
                                                    </p>
                                                </div>
                                            </li>
                
                                        </ul>

                                        <div class="pb-3">
                                           
                                            <p class="" v-if="!shapeAdded">
                                                {{ $t('game_session_memory_draw_shape_desc_1') }}
                                                <i class=" mdi mdi-18px mdi-shape-polygon-plus"></i>
                                                {{ $t('game_session_memory_draw_shape_desc') }}
                                            </p>
                                            <p class="" v-if="shapeAdded && !cardsDrawed">
                                                {{ $t('game_session_memory_draw_shape_desc_1') }}
                                                <i class=" mdi mdi-18px mdi-map-marker-multiple-outline"></i>
                                                {{ $t('game_session_memory_draw_cards_desc') }}
                                            </p>
                                            <p class="" v-if="cardsDrawed">
                                                {{ $t('game_session_memory_move_cards_desc') }}
                                                <i class="mdi mdi-18px mdi-close-thick"></i>
                                            </p>
                                        </div>
                                        
                                       <!-- <span
                                            class="button is-primary remove-shape selector-right px-2 py-0"
                                            @click="removeShape"
                                            :disabled="!shapeAdded"
                                        >
                                        {{ $t('remove_shape') }}
                                        </span>
                                        <span
                                            class="button is-eduloc-blue draw-objects px-2 py-0"
                                            @click="addObjects"
                                            :disabled="!shapeAdded || cardsDrawed"
                                            :title="$t('add_cards')"
                                        >
                                            {{ $t('add_cards') }}
                                        </span>-->
                                    </div>
                                    <div  ref="mapConfigurationContainer" class="map-configuration-container px-3 pb-3" :class="{'hidden':configuration.mode!='MAP'}">
                                       
                                        <l-map :zoom="zoom" :center="center" :bounds="mapBounds" ref="configurationMap" :options="{
                                            zoomControl: false,
                                            minZoom: 2,
                                            maxNativeZoom: 18,
                                            maxZoom: 24,
                                            editable: true,
                                        }"  style="z-index: 19" >
                                            <l-control-zoom position="bottomleft"></l-control-zoom>
                                            <!--<l-control-layers position="bottomright" :hideSingleBase="true" :collapsed="false"></l-control-layers>-->
                                            <l-control position="topright" >
                                                <div class="field has-addons">
                                                    <div class="control is-expanded">
                                                        <input
                                                            v-model="searchText"
                                                            class="input"
                                                            type="text"
                                                            :placeholder="
                                                                $t('Object.search_address_placeholder')
                                                            "
                                                        />
                                                    </div>
                                                    <div class="control">
                                                        <a
                                                            class="button is-primary"
                                                            @click="searchAddress"
                                                        >
                                                            <i class="fa fa-lg fa-caret-right" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </l-control>
                                              <l-control position="topleft" >
                                                
                                              <!--<span
                                                    class=" button selector-left px-2 py-0"
                                                    @click="addCircle"
                                                    :disabled="shapeAdded"
                                                    :class="{ 'is-selected is-eduloc-blue': activeShapeType == 'circle'}"
                                                    :title="$t('draw_circle')"
                                                >
                                                    <i class=" mdi mdi-18px mdi-shape-circle-plus "></i>
                                                </span>-->
                                                <span
                                                    class="button selector-left px-2 py-0"
                                                    v-if="!shapeAdded"
                                                    @click="addPolygon"
                                                    :disabled="shapeAdded"
                                                    :class="{ 'is-selected is-eduloc-blue': activeShapeType == 'polygon'}"
                                                    :title="$t('draw_rectangle')"
                                                >
                                                    <i class=" mdi mdi-18px mdi-shape-polygon-plus"></i>
                                                </span>
                                                <span
                                                    class="button selector-middle px-2 py-0"
                                                    @click="addObjects"
                                                    v-if="!cardsDrawed&&shapeAdded"
                                                    :class="{ 'is-selected is-eduloc-blue': shapeAdded&&cardsDrawed}"
                                                    :title="$t('draw_rectangle')"
                                                >
                                                    <i class=" mdi mdi-18px mdi-map-marker-multiple-outline"></i>
                                                </span>
                                                <!--<span class="button selector-middle px-2 py-0"
                                                    @click="addRectangle"
                                                    :disabled="shapeAdded"
                                                    :class="{ 'is-selected is-eduloc-blue':activeShapeType == 'rectangle'}"
                                                    :title="$t('draw_poligon')"
                                                >
                                                    <i class="mdi mdi-18px mdi-shape-rectangle-plus"></i>
                                                </span>-->
                                                <span
                                                    class="button is-primary selector-right px-2 py-0"
                                                    v-if="shapeAdded"
                                                    @click="removeShape"
                                                    :disabled="!shapeAdded"
                                                    
                                                >
                                                    <i class="mdi mdi-18px mdi-close-thick"></i>
                                                </span>
                                            </l-control>

                                            <l-tile-layer 
                                                :name="$t(tileProvider.name)" 
                                                :visible="true" :url="tileProvider.url" 
                                                :attribution="tileProvider.attribution"
                                                :layer-type="tileProvider.type" 
                                                :options="tileProvider.options" 
                                            />

                                            </l-map>
                                    </div>

                                    <!--<div v-if="configuration.mode=='MAP'" class=" px-3">
                                        <button :disabled="!shapeAdded" class="button is-eduloc-blue is-centered has-text-weight-bold">Repartir objectes</button>
                                    </div>-->
                                    
                                </div>

                                <!-- FI -->

                                <!-- Cal estar a prop per activar la pregunta? -->
                                <label v-if="isModeMap && isTrivial"
                                    v-t="'game_session_questions_behaivour'"
                                    class="label has-text-black px-4 column is-12 pb-0" 
                                ></label>
                                
                                <div v-if="isModeMap && isTrivial" class="column is-6 pr-0 pl-4 pt-0">
                                    <p
                                        ref="closerButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        :class="{'is-primary':configuration.closer}"
                                        @click.stop="setCloserOn"
                                    >
                                        {{$t(`game_session_question_closer`)}}
                                    </p>
                                </div>
                                <div v-if="isModeMap && isTrivial" class="column is-6 pl-0 pr-4 pt-0">
                                    <p
                                        ref="chosingButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        :class="{'is-primary':!configuration.closer}"
                                        @click.stop="setCloserOff"
                                    >
                                        {{$t(`game_session_question_choose`)}}
                                    </p>
                                </div>
                                <!--<div v-if="isModeMap && isTrivial">
                                    <label
                                        v-if="configuration.closer"
                                        v-t="'game_session_question_closer_desc'"
                                        class="label is-italic pl-4"
                                    ></label>
                                    <label
                                        v-else
                                        v-t="'game_session_question_choose_desc'"
                                        for="appmode"
                                        class="label is-italic pl-4 desc-label"
                                    ></label>
                                </div>-->
                                <!-- FI -->
                                
                                <!-- Missatge de finalització del joc -->
                                <!--<div class="column is-12" v-if="isTrivial">
                                    <div class="field">
                                        <label
                                            v-t="'Sessions.show_at_end'"
                                            class="label has-text-black"
                                        ></label>
                                        <div class="control is-expanded">
                                            <textarea
                                                rows="3"
                                                v-model="configuration.feedback"
                                                :placeholder="$t('Sessions.end_of_game_info')"
                                                class="textarea has-fixed-size"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <label
                                    v-t="'game_session_end_text_desc'"
                                    class="label is-italic desc-label"
                                    v-if="isTrivial"
                                ></label>
                                </div>-->
                            
                                 <!-- Configuració avançada -->
                                <div class="px-4 pb-4 pt-4 advanced-configuration" v-if="!isMemory">
                                    <div class="title-zone pb-4">
                                        <a @click="toggleAdvancedConfiguration" class="configuration-link">{{$t('advanced_configuration')}}</a>
                                        <span class="ml-4 secondary-font">{{$t('advanced_configuration_desc')}}</span>
                                    </div>
                                    <div class="advanced-configuration-content" v-if="showAdvancedConfiguration">
                                        <!-- Configuracions específiques del joc de pistes -->
                                        <div class="options pb-4" v-if="isTreasureHunt">

                                            <div class="columns is-mobile is-vcentered">
                                                <div class="column">
                                                    <p class="secondary-font">
                                                        {{$t('can_skip_clue')}}
                                                    </p>
                                                    <p class=" is-size-7 secondary-font">
                                                        {{$t('can_skip_clue_desc')}}
                                                    </p>
                                                </div>
                                                <div class="column is-narrow">
                                                    <label class="secondary-font">
                                                        <label class="switch ml-1">
                                                            <input
                                                                v-model="configuration.skipClue"
                                                                type="checkbox"
                                                            />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="columns is-mobile is-vcentered">
                                                <div class="column">
                                                    <p class="secondary-font">
                                                        {{$t('can_compass')}}
                                                    </p>
                                                    <p class=" is-size-7 secondary-font">
                                                        {{$t('can_compass_desc')}}
                                                    </p>
                                                </div>
                                                <div class="column is-narrow">
                                                    <label class="secondary-font">
                                                        <label class="switch ml-1">
                                                            <input
                                                                v-model="configuration.compass"
                                                                type="checkbox"
                                                            />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="columns is-mobile is-vcentered">
                                                <div class="column">
                                                    <p class="secondary-font">
                                                        {{$t('can_distance')}}
                                                    </p>
                                                    <p class=" is-size-7 secondary-font">
                                                        {{$t('can_distance_desc')}}
                                                    </p>
                                                </div>
                                                <div class="column is-narrow">
                                                    <label class="secondary-font">
                                                        <label class="switch ml-1">
                                                            <input
                                                                v-model="configuration.distance"
                                                                type="checkbox"
                                                            />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </label>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <!-- FI -->

                                        <!-- Configuracions específiques del memory -->
                                         <!-- FI -->

                                        <!-- Puntuacions -->
                                        <p class="has-text-black pb-4">{{$t('game_scores')}}</p>
                                        
                                        <div class="columns is-multiline" v-if="isTreasureHunt">
                                            <!-- punts per pista resolta -->
                                            <div class="column is-6">
                                                <div class="select is-inline-block" >
                                                    <select v-model="configuration.clueSolvedPoints">
                                                        <option :key="option.label" v-for="option in pointsValues" :value="option.value" >{{$t(`plus_${option.label}`)}}</option>
                                                    </select>
                                                </div>
                                                <div class="is-inline-block ml-2">
                                                    <p class="secondary-font mb-0 base-title">{{$t('solved_clue')}}</p>
                                                    <p class="label is-italic secondary-font explanation">{{$t('solved_clue_desc')}}</p>
                                                </div>
                                            </div>
                                            <!-- punts per pista saltada -->
                                            <div class="column is-6">
                                                <div class="select is-inline-block">
                                                    <select v-model="configuration.clueSkippedPoints"  :disabled="!configuration.skipClue">
                                                        <option :key="option.label" v-for="option in pointsValues" :value="option.value" >{{$t(`minus_${option.label}`)}}</option>
                                                    </select>
                                                </div>
                                                <div class="is-inline-block">
                                                    <p class="secondary-font ml-2 pt-3" :class="{'label':!configuration.skipClue}">{{$t('skip_clue')}}</p>
                                                </div>
                                            </div>
                                            <!-- Es permet brúixola? -->
                                            <div class="column is-6">
                                                <div class="select is-inline-block">
                                                    <select v-model="configuration.compassPoints" :disabled="!configuration.compass">
                                                        <option :key="option.label" v-for="option in pointsValues" :value="option.value" >{{$t(`minus_${option.label}`)}}</option>
                                                    </select>
                                                </div>
                                                <div class="is-inline-block">
                                                    <p class="secondary-font ml-2 pt-3" :class="{'label':!configuration.compass}">{{$t('compass_helper')}}</p>
                                                </div>
                                            </div>
                                            <!-- Es permet distància? -->
                                            <div class="column is-6">
                                                <div class="select is-inline-block">
                                                    <select v-model="configuration.distancePoints" :disabled="!configuration.distance">
                                                        <option :key="option.label" v-for="option in pointsValues" :value="option.value" >{{$t(`minus_${option.label}`)}}</option>
                                                    </select>
                                                </div>
                                                <div class="is-inline-block">
                                                    <p class="secondary-font ml-2 pt-3" :class="{'label':!configuration.distance}">{{$t('distance_helper')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="separator mb-5" v-if="isTreasureHunt"/>
                                        <div class="columns is-multiline" >
                                            <!-- Punts per pregunta encertada -->
                                            <div class="column is-6">
                                                <div class="select is-inline-block">
                                                    <select v-model="configuration.solvedQuestionPoints">
                                                        <option :key="option.label" v-for="option in pointsValues" :value="option.value" >{{$t(`plus_${option.label}`)}}</option>
                                                    </select>
                                                </div>
                                                <div class="is-inline-block">
                                                    <p class="secondary-font ml-2 pt-3">
                                                        <span v-if="isMemory">{{$t('solved_couple')}}</span>
                                                        <span v-else>{{$t('solved_question')}}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <!-- Punts per pregunta fallada -->
                                            <div class="column is-6">
                                                <div class="select is-inline-block">
                                                    <select v-model="configuration.failedQuestionPoints">
                                                        <option :key="option.label" v-for="option in pointsValues" :value="option.value" >{{$t(`minus_${option.label}`)}}</option>
                                                    </select>
                                                </div>
                                                <div class="is-inline-block">
                                                    <p class="secondary-font ml-2 pt-3">
                                                        <span v-if="isMemory">{{$t('failed_couple')}}</span>
                                                        <span v-else>{{$t('failed_question')}}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <p class="has-text-black pb-4" v-if="!isMemory">{{$t('time_question_title')}}</p>
                                        <div class="columns is-multiline" v-if="!isMemory">
                                            <div class="column is-12">
                                                <p class="label is-italic pl-4 desc-label">
                                                    {{$t('time_question_description')}}
                                                </p>
                                            </div>
                                            <!-- Activar temps de descompte? -->
                                            <div class="column is-6" >
                                                <div class="is-inline-block">
                                                    <label class="switch ml-1">
                                                        <input
                                                            v-model="configuration.useTime"
                                                            type="checkbox"
                                                        />
                                                        <span class="slider round"></span>
                                                    </label>

                                                </div>
                                                <div class="is-inline-block">
                                                    <p class="secondary-font ml-2 pt-3">
                                                        <span>{{$t('use_time_question')}}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <!-- Temps de descompte en segons -->
                                            <div class="column is-6">
                                                <div class="columns">
                                                    <div class="column is-5 pr-0">
                                                        <input v-model="configuration.timePerQuestion" class="input secondary-font" type="number">
                                                    </div>
                                                    <div class="column is-7 pl-0">
                                                        <p class="secondary-font ml-2 pt-3">
                                                            <span>{{$t('time_question')}}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            

                                        </div>
                                        
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
            </section>
            <footer class="modal-card-foot is-block px-6 py-5 is-radiusless">
                <div class="columns is-mobile">
                        <div class="column is-6">
                            <button class="button is-primary is-outlined" :class="{'disabled':creating}" :disabled="creating" @click="$emit('close')">{{$t('Buttons.cancel')}}</button>                      
                        </div>

                        <div class="column is-6">
                            <button @click="createSession" :class="{'disabled':creating}" :disabled="creating" class="button is-primary is-pulled-right">{{$t('save')}}</button>
                        </div>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import { updateItem } from '@/services/API';
import InputDatetime from '@/components/InputDatetime';
import moment from 'moment';
import _ from 'underscore';
import { POINTS_DEFAULT } from '@/lib/constants';

import * as L from 'leaflet';
require('leaflet.path.drag');
require('leaflet-editable');
import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LControl,
    LControlLayers,
    LControlZoom,
    LCircle,
    LPolygon,
    LRectangle,
    LTooltip
} from 'vue2-leaflet';

import bbox from '@turf/bbox';
import { point, polygon } from '@turf/helpers';
import { distance } from "@turf/distance";
import { buffer } from "@turf/buffer";
import { centerOfMass } from "@turf/center-of-mass";
import { center } from "@turf/center";
import { booleanWithin } from "@turf/boolean-within";
import Swal from 'sweetalert2';
import GeoCodingOSM from 'geocoding-osm'

export default {
    components: {
        InputDatetime,
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup,
        LControl,
        LControlLayers,
        LControlZoom,
        LCircle,
        LPolygon,
        LRectangle,
        LTooltip,
    },
    props: {
        session: {type: Object, default: {}},
    },
    data() {
        return {
            creating: false,
            allowsReset: this.session.allowsReset,
            showCreationWarning: true,
            showCreationError: false,
            creationError: false,
            minDate: moment().toISOString(),
            configuration: {
                mode: this.session.configuration.mode || this.isModeMap != true ? 'TRIVIAL' : 'MAP',
                time: this.session.configuration.time || 2,
                timeUnits: this.session.configuration.timeUnits || 'minutes',
                closer: this.session.configuration.closer,
                availability: this.session.configuration.availability || false,
                app: this.session.configuration.app || true,
                web: this.session.configuration.web || false,
                skipClue: this.session.configuration.skipClue,
                clueSkippedPoints: this.session.configuration.clueSkippedPoints || 0,
                clueSolvedPoints: this.session.configuration.clueSolvedPoints || 50,
                compass: this.session.configuration.compass,
                compassPoints: this.session.configuration.compassPoints || 20,
                distance: this.session.configuration.distance,
                distancePoints: this.session.configuration.distancePoints || 10,
                solvedQuestionPoints: this.session.configuration.solvedQuestionPoints || 10,
                failedQuestionPoints: this.session.configuration.failedQuestionPoints || 0,
                gameZone: this.session.configuration.gameZone || [],
                turnTime: this.session.configuration.turnTime || 1,
                players: this.session.configuration.players || 1,
                cardsBounds: this.session.configuration.cardsBounds || [],
                useTime: this.session.configuration.useTime,
                timePerQuestion: this.session.configuration.timePerQuestion || 15,
                
            },
            title: this.session.title || "",    
            showInfo: false,
            showAdvancedConfiguration: false,
            pointsValues: POINTS_DEFAULT,
            tileProvider:  {
                name: 'OpenStreetMap',
                visible: false,
                type: 'base',
                attribution:
                    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                image: 'osm.png',
                options: { maxNativeZoom: 24, maxZoom: 24 }
            },
            zoom: 6,
            center: [40, -2],
            configMap: {},
            latitude: 42,
            longitude: 2,
            activeShapeType: '',
            activeShape: {},
            cardsCoords: [],
            cardsDrawed: false,
            questionIcon: {
                iconUrl: '/img/map-icons/00_question.svg',
                iconSize:     [32, 37], 
                iconAnchor:   [16, 37], 
            },
            searchText: '',
        };
    },
    computed: {
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
        isTreasureHunt() {
            return this.$store.getters.project.type == 'treasurehunt' || this.$store.getters.project.format == 'PROJECT_TYPE_TREASUREHUNT';
        },
        isMemory() {
            return this.$store.getters.project.type == 'memory' || this.$store.getters.project.format == 'PROJECT_TYPE_MEMORY';
        },
        isQuizHunt() {
            return this.$store.getters.project.type == 'quizhunt' || this.$store.getters.project.format == 'PROJECT_TYPE_QUIZHUNT';
        },
        objects() {
            return this.$store.getters.projectContent;
        },
        limitedAvailability() {
            return this.configuration.availability;
        },
        isModeMap() {
            return this.$store.getters.project.mode == 'map' || this.$store.getters.project.format == 'PROJECT_TYPE_MEMORY';
        },
        mapBounds() {
            if (this.configuration.gameZone.length) {
                // console.log("game zone",this.configuration.gameZone)
                return L.latLngBounds(this.configuration.gameZone);
            } else {
                let bounds = [];

                const success = (position) => {
                    this.latitude  = position.coords.latitude;
                    this.longitude = position.coords.longitude;
                    // console.log(position.coords.latitude,position.coords.longitude)

                    // Do something with the position
                };

                const error = (err) => {
                    console.log(error)
                };

                // This will open permission popup
                navigator.geolocation.getCurrentPosition(success, error);

                bounds.push([this.latitude, this.longitude]);
                // console.log("adding new bound", element.location)
                let new_latitude = this.latitude + (0.10 / ((2 * Math.PI / 360) * 6378.137));
                let new_longitude = this.longitude + (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos(this.latitude * Math.PI / 180);
                // console.log(new_latitude,new_longitude)
                bounds.push(
                    //this.$options.filters.toLatLon({ 'latitude': new_latitude, 'longitude': new_longitude })
                    [ new_latitude,new_longitude]
                );
                let new_latitude2 = this.latitude - (0.10 / ((2 * Math.PI / 360) * 6378.137));
                let new_longitude2 = this.longitude - (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos(this.latitude * Math.PI / 180);
                bounds.push(
                    //this.$options.filters.toLatLon({ 'latitude': new_latitude2, 'longitude': new_longitude2 })
                    [ new_latitude2,new_longitude2]
                );

                // console.log("bounds",bounds)
                return L.latLngBounds( bounds );
            }
        },
        shapeAdded() {
            // console.log(this.activeShape)
            return Object.keys(this.activeShape).length > 0;
        },
    },
    mounted() {
        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });

        this.$nextTick(() => {
            if(this.$refs.configurationMap){
                this.configMap = this.$refs.configurationMap.mapObject;
                
                this.configMap.on('editable:drawing:start', this.initActiveShape);
                this.configMap.on('editable:drawing:end', this.setActiveShape);

                

                //this.configMap.fitBounds(this.mapBounds);
                //this.configMap.setView([this.latitude,this.longitude], 10);

                if (this.configuration.gameZone && this.configuration.gameZone.coordinates) {
                    this.activeShapeType = 'polygon';
                    // console.log("gameZone",this.configuration.gameZone.coordinates)
                    this.activeShape = L.polygon(this.arrayCoordsToLeaflet(this.configuration.gameZone.coordinates));
                    this.activeShape.addTo(this.configMap);
                    // console.log("cards?", this.configuration.cardsBounds)
                    
                    this.setMapOn();

                    // console.log("objects", this.$store.getters.projectContent.length)
                    if (this.isMemory) {
                        if ((this.$store.getters.projectContent.length * 2) == this.session.context.length) {
                            if (this.configuration.cardsBounds.length) {
                                //this.cardsCoords.push([[c.bounds[1][0], c.bounds[1][1]], [c.bounds[0][0], c.bounds[0][1]]]);
                                for (let a = 0; a < this.configuration.cardsBounds.length; a++){
                                    // console.log("rectangleCoords",this.configuration.cardsBounds[a])
                                    let rectangle = L.rectangle(this.configuration.cardsBounds[a], {
                                    color: '#0066ff',
                                    weight: 1,
                                    fillOpacity: 0.4,
                                    className:"card",
                                    draggable: true
                                    }).addTo(this.configMap);
                                }

                                
                                
                                this.cardsDrawed = true;
                            }
                        } else {
                            this.addObjects();
                        }
                    } else if (this.isQuizHunt) {
                        if ((this.$store.getters.projectContent.length) == this.session.context.length) {
                            if (this.configuration.cardsBounds.length) {
                                //this.cardsCoords.push([[c.bounds[1][0], c.bounds[1][1]], [c.bounds[0][0], c.bounds[0][1]]]);
                                for (let a = 0; a < this.configuration.cardsBounds.length; a++){
                                
                                    L.marker([this.configuration.cardsBounds[a][0], this.configuration.cardsBounds[a][1]], {icon: L.icon(this.questionIcon), draggable: true}).addTo(this.configMap);
                                }
                                this.cardsDrawed = true;
                            }
                        } else {
                            this.addObjects();
                        }
                    }
                    
                    
                        
                }
                    
                setTimeout(() => {
                    // console.log(this.configuration)
                    this.configMap.invalidateSize();
                    
                }, 500);
            }

            //this.configMap.fitBounds(this.mapBounds);

        });

    },
    methods: {
        async createSession() {
            // console.log("createsession",this.configuration)
            this.creating = true;
            this.showCreationError = false;
            this.creationError = undefined;
            // console.log("checking geoquest")
            if (this.isModeMap == true && this.isTrivial) {
                const objectsContainsLocation = _.every(
                    this.objects,
                    (object) => {
                        return object.location;
                    }
                );
                if (!objectsContainsLocation) {
                    this.showCreationError = true;
                    this.creating = false;
                    return (this.creationError = this.$t(
                        'Sessions.error_objects_without_location'
                    ));
                }
                if (this.configuration.mode == 'TRIVIAL') {
                    // console.log('forcing change');
                    this.configuration.mode = 'MAP';
                }
            }
            if(!this.title){
                this.showCreationError = true;
                this.creating = false;
                return (this.creationError = this.$t(
                    'session_name_empty'
                ));
            }
            if (this.configuration.useTime) {
                if (this.configuration.timePerQuestion <= 0) {
                    this.showCreationError = true;
                    this.creating = false;
                    return (this.creationError = this.$t(
                        'session_time_per_question_empty'
                    ));
                }
            }
            if (this.isMemory) {
                if (Object.keys(this.activeShape).length && this.cardsCoords.length) {
                    let newGeo = this.activeShape.toGeoJSON();
                    if (this.activeShapeType == 'circle') {
                        // console.log(newGeo);
                        this.configuration.gameZone.radius = this.activeShape.getRadius(); //this.activeShape._mRadius;
                        this.configuration.gameZone.coordinates = newGeo.geometry.coordinates;
                        /*this.content.shape.coordinates = {
                            ...this.activeShape._latlng,
                        };
                        delete this.content.shape.coordinates.__vertex;*/
                    } else {
                        /*this.content.shape.coordinates =
                            this.activeShape.getLatLngs();*/
                        this.configuration.gameZone.coordinates = newGeo.geometry.coordinates;
                        // console.log(newGeo);
                        let objectsCoords=[]
                        this.configMap.eachLayer(function (layer) {
                            if (layer.options.className && layer.options.className == 'card') { 
                                // console.log([layer.getBounds()._northEast.lat, layer.getBounds()._northEast.lng], [layer.getBounds()._southWest.lat, layer.getBounds()._southWest.lng])
                                objectsCoords.push([[layer.getBounds()._northEast.lat, layer.getBounds()._northEast.lng], [layer.getBounds()._southWest.lat, layer.getBounds()._southWest.lng]])
                            }
                            

                        });
                        // console.log(newGeo);
                        this.cardsCoords = objectsCoords
                    }
                    this.configuration.cardsBounds = this.cardsCoords;
                }
            }
            if (this.isQuizHunt) {
                // console.log("saving quizhunt")
                if (Object.keys(this.activeShape).length && this.cardsCoords.length) {
                    let newGeo = this.activeShape.toGeoJSON();
                    this.configuration.gameZone = {};
                    this.configuration.gameZone.coordinates = newGeo.geometry.coordinates;
                    this.configuration.cardsBounds=[]
                    // console.log("checking layers",this.cardsCoords )
                    let objectsCoords=[]
                    this.configMap.eachLayer(function (layer) { 
                        if (layer.options.icon) {
                            //let markerCoords = layer.getLatLng();
                            //addCoords([markerCoords.lat,markerCoords.lng])
                            objectsCoords.push([layer.getLatLng().lat,layer.getLatLng().lng]);
                            // console.log("marker",layer)
                        }
                       
                    })
                    this.cardsCoords = objectsCoords
                    this.configuration.cardsBounds = objectsCoords;
                }

                
            }

            let mySession = { ...this.session }
            mySession.configuration = this.configuration;
            mySession.title = this.title;
            mySession.allowsReset = this.allowsReset;

            // console.log("session",mySession)

            let response = await updateItem(
                'session',
                mySession._id,
                mySession
            )
            .then((data) => {
                // console.log(data.data.context.length)
                this.creating = false;
                    this.$store.dispatch('setSession', data.data).then(() => { 
                        this.$emit('close');
                    })
                        .catch((e) => {
                    this.creating = false;
                    this.creationError = e;
                    this.showCreationError = true;
                });
            })
            .catch((e) => {
                this.creationError = e;
                this.showCreationError = true;
            });
            /*let session = await updateItem('session', {
                configuration: this.configuration,
                project: this.$store.getters.project._id,
                title: this.title,
                shortCode: this.code,
                allowsReset: this.allowsReset,
                isActive: true
            });
            
            this.creating = false;
            this.$store.dispatch('setSession', session.data).catch((e) => {
                this.creating = false;
                this.creationError = e;
                this.showCreationError = true;
            });
            console.log("session created", session)
            this.$emit('sessionActivation');
            this.$emit('close');*/
        },
        setApp() {
            this.configuration.app = true;
            this.configuration.web = false;
            if (!this.$refs.appButton.classList.contains('is-primary')) {
                this.$refs.appButton.classList.add('is-primary');
                this.$refs.webButton.classList.remove('is-primary');
            }
        },
        setWeb() {
            this.configuration.app = false;
            this.configuration.web = true;
            if (!this.$refs.webButton.classList.contains('is-primary')) {
                this.$refs.webButton.classList.add('is-primary');
                this.$refs.appButton.classList.remove('is-primary');
            }
        },
        discardUnsavedChanges() {
            // console.log('discard');
            this.$emit('cancel');
        },
        setCloserOn() {
            this.configuration.closer = true;
            if (!this.$refs.closerButton.classList.contains('is-primary')) {
                this.$refs.closerButton.classList.add('is-primary');
                this.$refs.chosingButton.classList.remove('is-primary');
            }
        },
        setCloserOff() {
            this.configuration.closer = false;
            if (!this.$refs.chosingButton.classList.contains('is-primary')) {
                this.$refs.chosingButton.classList.add('is-primary');
                this.$refs.closerButton.classList.remove('is-primary');
            }
        },
        setResetOn() {
            this.allowsReset = true;
            if (!this.$refs.canResetButton.classList.contains('is-primary')) {
                this.$refs.canResetButton.classList.add('is-primary');
                this.$refs.preventResetButton.classList.remove('is-primary');
            }
        },
        setResetOff() {
            this.allowsReset = false;
            if (!this.$refs.preventResetButton.classList.contains('is-primary')) {
                this.$refs.preventResetButton.classList.add('is-primary');
                this.$refs.canResetButton.classList.remove('is-primary');
            }
        },
        toggleAdvancedConfiguration() {
            this.showAdvancedConfiguration = !this.showAdvancedConfiguration;
        },
        setMapOn() {
            this.configuration.mode = "MAP";
            if (!this.$refs.mapButton.classList.contains('is-primary')) {
                this.$refs.mapButton.classList.add('is-primary');
                this.$refs.cardButton.classList.remove('is-primary');
                this.configMap.fitBounds(this.mapBounds);
                //this.configMap.setView([this.latitude,this.longitude], 10);
            setTimeout(() => {
                this.configMap.invalidateSize();
                //this.configMap.fitBounds(this.mapBounds);
                //const newBounds = this.activeShape.getBounds();
                // console.log(newBounds)
                //this.configMap.fitBounds(newBounds);
                if (this.activeShape && Object.keys(this.activeShape).length != 0) {
                    this.configMap.fitBounds(this.activeShape.getBounds());
                } else {
                    this.configMap.fitBounds(this.mapBounds);
                }
                //this.configMap.editTools.startPolygon();
            }, 500);
            }
        },
        setMapOff() {
            this.configuration.mode = "TRIVIAL";
            if (!this.$refs.cardButton.classList.contains('is-primary')) {
                this.$refs.cardButton.classList.add('is-primary');
                this.$refs.mapButton.classList.remove('is-primary');
            }
        },
        addCircle() {
            // console.log('start event');
            this.activeShapeType = 'circle';
            //console.log("editable map?",this.configMap)
            //console.log("activeShape",this.activeShape);
            this.configMap.editTools.startCircle();
        },
        addPolygon() {
            this.activeShapeType = 'polygon';
            this.configMap.editTools.startPolygon();
        },
        addRectangle() {
            this.activeShapeType = 'rectangle';
            this.configMap.editTools.startRectangle();
        },
        removeShape() {
            this.activeShapeType = '';
            this.configMap.removeLayer(this.activeShape);
            this.activeShape = {};
            this.cardsCoords = [];
            this.configMap.eachLayer(function (layer) {
                // console.log(layer)
                if(layer.options.className && layer.options.className=="card"){
                    //this.configMap.removeLayer(layer);
                    layer.remove();
                }
            })
            this.cardsDrawed = false;
            
        },

        addObjects() {
            // console.log("adding objects",this.objects.length)
            //console.log("shape", this.activeShape.getLatLngs());

            this.activeShape.disableEdit();

            const newGeo = this.activeShape.toGeoJSON();
            const turfPolygon = polygon([newGeo.geometry.coordinates[0]]);
            //console.log("a definir el espacio de cada carta")

            // Rectángulo de 3.5m x 2m
            const [heightDeg, widthDeg] = this.metrosAGrados(3.5, 2, centerOfMass(turfPolygon).geometry.coordinates[1]);
            const rectSize = [heightDeg, widthDeg];
            const separation = 5; // metros entre rectángulos
            const [sepLat, sepLng] = this.metrosAGrados(separation, separation, centerOfMass(turfPolygon).geometry.coordinates[1]);

            //console.log("rectángulo definido")

            //console.log("definimos margen interior")  
            // Buffer interno de 2 metros
            const innerPolygon = buffer(turfPolygon, -2, { units: 'meters' });

            // Bounding box reducido
            const turfBbox = bbox(innerPolygon);

            const candidates = [];
            const maxTries = 500;
            let placedRects = [];

            let cardsNumber = this.objects.length;
            if (this.isMemory) {
                cardsNumber = this.objects.length * 2;
            } 

            for (let i = 0; i < maxTries && candidates.length < cardsNumber; i++) {
                const randLng = Math.random() * (turfBbox[2] - turfBbox[0]) + turfBbox[0];
                const randLat = Math.random() * (turfBbox[3] - turfBbox[1]) + turfBbox[1];
  
                const turfCenter = [randLng, randLat];
  
                const rectPoly = polygon([[
                    [turfCenter[0] - widthDeg / 2, turfCenter[1] - heightDeg / 2],
                    [turfCenter[0] + widthDeg / 2, turfCenter[1] - heightDeg / 2],
                    [turfCenter[0] + widthDeg / 2, turfCenter[1] + heightDeg / 2],
                    [turfCenter[0] - widthDeg / 2, turfCenter[1] + heightDeg / 2],
                    [turfCenter[0] - widthDeg / 2, turfCenter[1] - heightDeg / 2]
                ]]);
  
                // Validar que esté dentro del polígono
                if (!booleanWithin(rectPoly, innerPolygon)) continue;
  
                // Validar distancia a otros rectángulos
                const isFarEnough = placedRects.every(prev => {
                    const dist = distance(center(rectPoly), center(prev), { units: 'meters' });
                    return dist >= separation;
                });
  
                if (isFarEnough) {
                    placedRects.push(rectPoly);
                    candidates.push({
                    turfCenter,
                    bounds: [
                        [turfCenter[1] - heightDeg / 2, turfCenter[0] - widthDeg / 2],
                        [turfCenter[1] + heightDeg / 2, turfCenter[0] + widthDeg / 2]
                    ]
                    });
                }
            }

            // Mostrar rectángulos en el mapa
            if (candidates.length < cardsNumber) {
                // console.log("no space",candidates.length)
                alert('more_space_needed')
                
                return;

            }

            candidates.forEach(c => {
                // console.log("point", c)
                if (this.isMemory) {
                    let rectangleCoords = [[c.bounds[1][0], c.bounds[1][1]], [c.bounds[0][0], c.bounds[0][1]]];
                    this.cardsCoords.push([[c.bounds[1][0], c.bounds[1][1]], [c.bounds[0][0], c.bounds[0][1]]]);
                    let rectangle = L.rectangle(rectangleCoords, {
                    color: '#0066ff',
                    weight: 1,
                    fillOpacity: 0.4,
                    className:"card",
                    draggable: true
                    }).addTo(this.configMap);
                } else {
                    this.cardsCoords.push([c.turfCenter[1], c.turfCenter[0]]);
                    L.marker([c.turfCenter[1], c.turfCenter[0]], {icon: L.icon(this.questionIcon), draggable: true}).addTo(this.configMap);
                }
            });
            this.cardsDrawed = true;

        },
        leafletCoordsToArray(coords) {
            // console.log("cords", coords)
            let arrayCoords = [];
            for (let ind = 0; ind < coords[0].length; ind++){
                // console.log(coords[0][ind].lat, coords[0][ind].lng)
                arrayCoords.push([coords[0][ind].lat, coords[0][ind].lng])
            }
            arrayCoords.push([coords[0][0].lat, coords[0][0].lng])
            return arrayCoords;
        },
        // Conversión aproximada de metros a grados
        metrosAGrados(mLat, mLng, latRef) {
            // console.log("metros a grados")
            const latDeg = mLat / 111320;
            const lngDeg = mLng / (111320 * Math.cos(latRef * Math.PI / 180));
            return [latDeg, lngDeg];
        },

        initActiveShape(e) {
            // console.log('initActiveShape', e);

            this.activeShape = {};
        },

        setActiveShape(e) {
            // console.log('setActiveShape', e);

            this.activeShape = e.layer;
        },

        canDrawPolygon(object) {
            /*console.log(
                'canDrawPolygon',
                object.shape.type == 'polygon' &&
                    (!this.activeObject || object._id != this.activeObject._id)
            );*/

            if (object.shape.type == 'polygon') {
                if (!this.activeObject && !this.editionEnabled) {
                    /*console.log(
                        'no active object and edition enabled for',
                        object.title
                    );*/
                    return true;
                } else if (
                    this.activeObject &&
                    object._id != this.activeObject._id
                ) {
                    /*console.log(
                        'active object with different id',
                        object._id,
                        this.activeObject._id
                    );*/
                    return true;
                } else if (!this.editionEnabled) {
                    // console.log('no edition enabled');
                    return true;
                }
                return false;
            }
            
        },
        getMapClickPosition(e) {
            console.log("click position", e)
            
        },
        arrayCoordsToLeaflet(coords) {
            // console.log("cords", coords)
            let leafletCoords = [];
            for (let ind = 0; ind < coords[0].length; ind++){
                //console.log(coords[0][ind].lat, coords[0][ind].lng)
                leafletCoords.push([coords[0][ind][1], coords[0][ind][0]])
            }
            //arrayCoords.push([coords[0][0].lat, coords[0][0].lng])
            return leafletCoords;
        },
        async searchAddress() {
            let searchLocale = this.$i18n.locale;
            if (this.$i18n.locale === 'ca-ES') {
                searchLocale = 'ca_ES';
            }
            if (this.searchText.length > 5) {
                const searchParams = {
                    q: this.searchText,
                    'accept-language': searchLocale,
                    limit: 1,
                };
                const geoCodingOSM = new GeoCodingOSM();

                const response = await geoCodingOSM.search(searchParams);

                if (response[0]) {
                    // console.log("add point to", response[0])
                    this.configMap.flyTo([response[0].lat, response[0].lon], 18);
                    // this.$emit('addPoint', response[0]);
                    // console.log(this.content);
                }else {
                    Swal.fire({
                        title: this.$t('no_address_found'),
                        text: this.$t('no_address_found_message'),
                        showCancelButton: false,
                        confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    })/*.then((result) => {
                        if (result.isConfirmed) {
                            this.removeFolder(item);
                        }
                    })*/;
                }
            }
        },
    },
    

};
</script>

<style scooped>
@import '../assets/css/leftPanel.css';
.new-session {
    overflow-y: auto;
    max-height: calc(100vh - 95px);
    overflow-x: hidden;
}

.button.is-multiline {
  min-height: 2.25em;
  white-space: unset;
  height: auto;
  flex-direction: column;
}
.game-creation-info p, .desc-label{
    font-family: var(--secondary-font);
}
.modal-card-foot .button{
    font-family: var(--primary-font);
}
.explanation{
    line-height: 0.8rem;
}
.base-title{
    margin-top: 0.1rem;
}
.configuration-link{
    color:var(--eduloc-red);
    text-decoration: underline;
}
.configuration-link:hover{
    color:var(--eduloc-red);
}
.separator{
    height: 1px;
    width: 100%;
    background-color:var(--eduloc-grey-light)
}
.desc-label{
    color:#4a4a4a;
}
.map-configuration-container .leaflet-container {
    height: 300px;
}
.map-controls .button{
    border-radius: 0;
    height: 3rem;
}
.map-controls .draw-area[disabled]{
    display:none;
}
.map-controls .remove-shape[disabled]{
    display:none;
}
.steps{
    list-style-type: none;
}

</style>
